module.exports = __webpack_public_path__ + "static/media/HO20.8a9ee032.png";